<template>
  <div class="row mx-0">
    <div class="col-12">
      <div class="p-0 m-0 mt-4 main-title">權限設定</div>
      <div class="row mx-0">
        <div class="col-12 px-0 order-3 order-xxl-2">
          <nav class="px-0">
            <div class="nav nav-tabs mes-tabs" id="nav-tab" role="tablist">
              <button
                class="nav-link mes-tab"
                :class="{ active: tabIndex == 0 }"
                id="nav-user-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-user"
                type="button"
                role="tab"
                aria-controls="nav-user"
                aria-selected="true"
                @click="tabIndex = 0"
              >
                使用者
              </button>
              <button
                class="nav-link mes-tab"
                :class="{ active: tabIndex == 1 }"
                id="nav-role-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-role"
                type="button"
                role="tab"
                aria-controls="nav-role"
                aria-selected="false"
                @click="tabIndex = 1"
              >
                角色
              </button>
              <button
                class="nav-link mes-tab"
                :class="{ active: tabIndex == 2 }"
                id="nav-webPage-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-webPage"
                type="button"
                role="tab"
                aria-controls="nav-webPage"
                aria-selected="false"
                @click="tabIndex = 2"
              >
                網頁頁面
              </button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <template v-if="tabIndex == 0">
              <div
                class="tab-pane fade show active"
                :class="{}"
                id="nav-user"
                role="tabpanel"
                aria-labelledby="nav-user-tab"
              >
                <permissionSettingUser />
              </div>
            </template>
            <template v-if="tabIndex == 1">
              <div
                class="tab-pane fade show active"
                :class="{}"
                id="nav-role"
                role="tabpanel"
                aria-labelledby="nav-role-tab"
              >
                <permissionSettingRole />
              </div>
            </template>
            <template v-if="tabIndex == 2">
              <div
                class="tab-pane fade show active"
                :class="{}"
                id="nav-webPage"
                role="tabpanel"
                aria-labelledby="nav-webPage-tab"
              >
                <permissionSettingWebPage />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import permissionSettingUser from "@/components/permissionSetting/permissionSettingUser.vue";
import permissionSettingRole from "@/components/permissionSetting/permissionSettingRole.vue";
import permissionSettingWebPage from "@/components/permissionSetting/permissionSettingWebPage.vue";
export default {
  components: {
    permissionSettingUser,
    permissionSettingRole,
    permissionSettingWebPage,
  },
  setup() {
    const tabIndex = ref(0);

    return {
      tabIndex,
    };
  },
};
</script>

<style></style>
